import React, { useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { DialogStep } from '@modernloop/shared/components';
import { useGenericOnError } from '@modernloop/shared/hooks';

import useDeleteCandidateAvailabilityOptions from './useDeleteCandidateAvailabilityOptions';

type Props = {
  candidateAvailabilityOptionsId: string;
  onClose: () => void;
  onDelete?: () => void;
};

const DeleteCandidateAvailabilityConfirmationDialog = ({
  candidateAvailabilityOptionsId,
  onClose,
  onDelete,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const handleError = useGenericOnError();

  const [deleting, setDeleting] = useState(false);

  const { deleteCandidateAvailabilityOptionsMutation } = useDeleteCandidateAvailabilityOptions();

  const handleDelete = async () => {
    const optionsId = candidateAvailabilityOptionsId;
    if (!optionsId) {
      return;
    }

    setDeleting(true);

    try {
      await deleteCandidateAvailabilityOptionsMutation({
        variables: { id: optionsId },
      });
      onDelete?.();
      onClose();
    } catch (error) {
      handleError({ error });
    }
    setDeleting(false);
  };
  return (
    <DialogStep
      title={t('hiring-dashboard-candidates:candidates.deleteAvailability.cancelRequestTitle')}
      submitOptions={{
        label: t('hiring-dashboard-candidates:candidates.deleteAvailability.cancelRequestButton'),
        onClick: handleDelete,
        isDangerous: true,
        isDisabled: deleting,
      }}
      cancelOptions={{
        label: t('hiring-dashboard-candidates:candidates.deleteAvailability.dontCancel'),
        onClick: onClose,
      }}
      onClose={onClose}
    >
      {t('hiring-dashboard-candidates:candidates.deleteAvailability.cancelRequestBody')}
    </DialogStep>
  );
};

export default DeleteCandidateAvailabilityConfirmationDialog;
